<template>
    <b-modal
        id="management-modules-management-add-admin"
        :title="$t('management.add_user')"
        :ok-title="$t('common.close')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        ok-variant="primary"
        size="md-custom"
        modal-class="apprentice-default-modal">
        <design-2021-apprentice-data-table
            :fields="fields"
            :items="teachersIn">
            <template v-slot:cell(actions)="row">
                <b-button
                    class="btn-user-add btn-add-user-to-module"
                    variant="primary-icon-only"
                    @click="storeTeacher(row.item)">
                </b-button>
            </template>
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-management-modules-management-add-admin-modal-component',
    props: ['teachersIn'],
    data() {
        return {
            fields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    methods: {
        storeTeacher(teacher) {
            let data = {
                user_id: teacher.id,
            };

            this.axios.post(this.routes.moduleManagementAddTeacher(), data).then(
                (response) => {
                    for (const role of response.data.roles) {
                        if (role.name === 'module') {
                            teacher.addRelation('roles', role);
                        }
                    }
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
